type AboutSectionProps = {
  about: string;
};

export const AboutSection = ({ about }: AboutSectionProps): React.JSX.Element => (
  <section className="tw:overflow-hidden tw:rounded-xs tw:border tw:border-stroke tw:bg-white">
    <p className="tw:m-0 tw:whitespace-pre-line tw:px-4 tw:py-3 tw:text-sm tw:leading-relaxed tw:text-midnight/75">
      {about}
    </p>
  </section>
);
